import React from "react";
import { ScrollText } from "lucide-react";

const SECTIONS = [
  { h: "1. Description of Service", p: "My360Boss provides an online platform for non-supervisory employees to submit and view anonymous, 360-degree feedback, ratings, and reviews regarding workplace managers and supervisors." },
  { h: "2. User Eligibility & Account Registration", list: [
    "You must be at least 18 years of age to use this Service.",
    "If you create an account, you agree to provide accurate registration information and keep your credentials secure. You are responsible for all activities occurring under your account.",
  ] },
  { h: "3. Content Submission & Community Guidelines", intro: "By submitting reviews, ratings, comments, or other content (\"User Content\") on My360Boss, you agree that:", list: [
    "Honest Experience: All feedback must reflect your own genuine, first-hand workplace experiences.",
    "No Defamation or False Statements: You will not post false factual claims, unsubstantiated allegations of criminal activity, or defamatory statements.",
    "No Personally Identifiable Information (PII): You will not post personal phone numbers, physical addresses, private email addresses, or specific private details of any individual.",
    "No Harassment or Hate Speech: Profanity, discriminatory remarks, hate speech, threats, and targeted harassment are strictly prohibited.",
    "No Confidential Business Data: You will not post trade secrets, proprietary business data, or non-public internal corporate documents.",
  ] },
  { h: "4. Platform Role & Disclaimer of Liability (User Content)", intro: "My360Boss acts purely as a passive conduit and hosting platform for user-generated content.", list: [
    "Opinions, ratings, and reviews published on the Service belong solely to the individual submitters and do not reflect the views or endorsements of My360Boss.",
    "My360Boss does not guarantee the accuracy, truthfulness, or integrity of any user content.",
    "To the maximum extent permitted by law, My360Boss disclaims all liability for any loss, claim, damage, or legal action arising from user submissions.",
  ] },
  { h: "5. Content Moderation & Right to Remove", p: "My360Boss reserves the right, but has no obligation, to review, flag, edit, or permanently remove any User Content at our sole discretion, without prior notice, if it violates these Terms or is reported as unlawful or defamatory." },
  { h: "6. Limitation of Liability", p: "In no event shall My360Boss, its owners, directors, or operators be liable for any indirect, incidental, consequential, or punitive damages arising out of your access to, use of, or inability to use the Service." },
  { h: "7. Changes to Terms", p: "We reserve the right to modify these Terms at any time. Continued use of the Service following any updates constitutes acceptance of those changes." },
];

export default function Terms() {
  return (
    <div className="max-w-3xl mx-auto px-5 sm:px-8 py-12">
      <p className="font-mono text-xs uppercase tracking-widest text-emerald-600 mb-2">Legal</p>
      <h1 className="font-display text-5xl text-slate-900 mb-3 flex items-center gap-3" style={{ fontWeight: 900 }}>
        <ScrollText className="text-emerald-600" size={38} /> Terms of Service
      </h1>
      <p className="text-xs text-slate-400 font-mono mb-6">Last Updated: August 24, 2026</p>

      <p className="text-slate-600 leading-relaxed mb-8">
        Welcome to My360Boss (my360boss.com). By accessing or using our website, platform, and services
        (collectively, the "Service"), you agree to be bound by these Terms of Service ("Terms"). If you do
        not agree to these Terms, please do not use the Service.
      </p>

      <div className="space-y-6" data-testid="terms-sections">
        {SECTIONS.map((s, i) => (
          <div key={i}>
            <h2 className="font-display text-xl text-slate-900 mb-1" style={{ fontWeight: 700 }}>{s.h}</h2>
            {s.p && <p className="text-slate-600 leading-relaxed text-sm">{s.p}</p>}
            {s.intro && <p className="text-slate-600 leading-relaxed text-sm mb-2">{s.intro}</p>}
            {s.list && (
              <ul className="list-disc pl-5 space-y-1.5 text-sm text-slate-600">
                {s.list.map((li, j) => <li key={j} className="leading-relaxed">{li}</li>)}
              </ul>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
